import { Alert, Col, Row, Input } from "reactstrap";
import React, { useEffect, useState } from "react";
import {
  getPublicMediaRequest,
  createPublicMediaMetadata,
  createPublicMedia,
} from "../../../services/apiActions/";

import Button from "../../../components/Button";
import { Check } from "react-feather";
import FileInput from "../../../components/FileInput";
import Loader from "../../../components/Loader";
import { AvField, AvForm } from "availity-reactstrap-validation";

export default function Details({ match }) {
  const [isLoading, setIsLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [organizationName, setOrganizationName] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [file, setFile] = useState(null);
  const [uploadComplete, setUploadComplete] = useState(false);
  const [progress, setProgress] = useState(null);
  const [logoSource, setLogoSource] = useState("");
  const [agree, setAgree] = useState(false);

  const [mediaMetadata, setMediaMetadata] = useState(null);
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

  useEffect(() => {
    const bodyElement = document.querySelector("body");
    bodyElement.style.backgroundColor = "#ffffff";
    getPublicMediaRequest(match.params.id, (response) => {
      setMessage(response.message);
      setIsLoading(false);
      setLogoSource(response.logoUrl);
      setOrganizationName(response.charityName);
    });
  }, [match.params.id]);

  const handleValidSubmit = async function (event, formValues) {
    setSubmitting(true);

    const mediaId = await createPublicMediaMetadata(
      match.params.id,
      mediaMetadata,
      file
    );

    await createPublicMedia(match.params.id, mediaId, file, (progress) =>
      setProgress(progress)
    );

    setUploadComplete(true);
    setProgress(null);
    setSubmitting(false);
    setAgree(false);
  };

  if (isLoading) return <Loader />;

  return (
    <div>
      <React.Fragment>
        <div className="text-center org-logo-share">
          <img
            src={logoSource}
            alt="logo"
            className="mr-2"
            style={{ maxWidth: 180, maxHeight: 180, display: "inline-block" }}
          />
        </div>

        {!uploadComplete && (
          <Row style={{ textAlign: "center" }}>
            <Col>
              <p className="huge-text" style={{ whiteSpace: "pre-wrap" }}>
                {message}
              </p>
              <p className="large-text">
                Click the button below to upload video or pictures.
              </p>
              <FileInput onChange={(event) => setFile(event.target.files[0])} />

              <div
                style={{
                  display: "inline-block",
                  textAlign: "left",
                  marginBottom: "25px",
                  marginTop: "25px",
                  paddingLeft: "15px",
                  paddingRight: "15px",
                }}
              >
                <p className="large-text" style={{ marginBottom: "0" }}>
                  Title
                </p>

                <input
                  style={{ width: "100%", marginBottom: "35px" }}
                  onChange={(e) => {
                    setMediaMetadata({
                      ...mediaMetadata,
                      name: e.target.value,
                    });
                  }}
                />

                <p className="large-text" style={{ marginBottom: "0" }}>
                  Notes (share more details about your media)
                </p>
                <textarea
                  style={{ width: "100%", height: "125px" }}
                  className="video-page-content-textarea"
                  onChange={(e) => {
                    setMediaMetadata({
                      ...mediaMetadata,
                      note: e.target.value,
                    });
                  }}
                />

                <p
                  style={{ marginTop: "25px", marginBottom: "25px" }}
                  className="large-text"
                >
                  Let us know who you are!
                </p>

                <AvForm>
                  <AvField
                    name="firstName"
                    label="First Name"
                    required
                    onChange={function (e) {
                      setMediaMetadata({
                        ...mediaMetadata,
                        firstName: e.target.value,
                      });
                    }}
                  />
                  <AvField
                    name="lastName"
                    label="Last Name"
                    required
                    onChange={function (e) {
                      setMediaMetadata({
                        ...mediaMetadata,
                        lastName: e.target.value,
                      });
                    }}
                  />
                  <AvField
                    type="email"
                    name="email"
                    label="Email"
                    required={email === "" && phone === ""}
                    onChange={function (e) {
                      setEmail(e.target.value);
                      setMediaMetadata({
                        ...mediaMetadata,
                        email: e.target.value,
                      });
                    }}
                    errorMessage="Email or Phone is required"
                  />
                  <AvField
                    type="phone"
                    name="phone"
                    label="Phone"
                    required={email === "" && phone === ""}
                    onChange={function (e) {
                      setPhone(e.target.value);
                      setMediaMetadata({
                        ...mediaMetadata,
                        phone: e.target.value,
                      });
                    }}
                    errorMessage="Email or Phone is required"
                  />
                </AvForm>
              </div>
              <p>
                <Input type="checkbox" onClick={() => setAgree(!agree)} /> I
                have read the{" "}
                <a
                  href="https://kindkatch.com/media-release-form/"
                  target="_new"
                >
                  media release
                </a>{" "}
                and consent for my media to be shared by {organizationName}.
              </p>
              <p className="mb-4">
                <Button
                  size="xl"
                  disabled={
                    submitting ||
                    !file ||
                    !agree ||
                    !mediaMetadata?.firstName ||
                    !mediaMetadata?.lastName ||
                    (!email && !phone)
                  }
                  onClick={handleValidSubmit}
                >
                  Submit
                </Button>
                <br />
                {progress && `${progress}% complete`}
              </p>
            </Col>
          </Row>
        )}
        {uploadComplete && (
          <div style={{ textAlign: "center" }}>
            <Alert color="success" className="alert-outline">
              <div className="alert-icon">
                <Check />
              </div>
              <div className="alert-message">
                Success! Thank you for sharing your media with us! <br />
              </div>
            </Alert>
            <Button size="xl" onClick={() => setUploadComplete(false)}>
              Upload more
            </Button>
          </div>
        )}
      </React.Fragment>
    </div>
  );
}
